import withLazy from 'hoc/withLazy';

const Carousel = () =>
    import(/* webpackChunkName: "components-Carousel" */ './Carousel');

export default withLazy(Carousel);
